import React, { Suspense, useEffect, useRef, useState } from "react";
import FormCreator from "../../components/forms/FormCreator";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { paginationObj } from "../../utils/Constants";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { useNavigate, useParams } from "react-router-dom";
import { encryptAESID } from "../../utils/Encryption";
import { BookingCancelationListConfig, BookingCancelationListFormData } from "./data/BookingCancelationListForm.Data";
import SwalAlert from '../../services/swalService/SwalService';
import { useGetBookingCancellationListMutation } from "../../app/services/BookingCancelation/BookingCancelationListServiceApi";

const BookingCancelationListForm = () => {
  const navigate = useNavigate();
  const filterRef = useRef();
  const [viewBookingList, setBookingList] = useState(BookingCancelationListFormData);
  const molGridRef = useRef();
  const { id } = useParams();
  const { confirm, success, error } = SwalAlert();
  const [dataSource, setDataSource] = useState();
  const [pagination, setPagination] = useState({
    ...paginationObj,
    filterStartDate: null,
    filterEndDate: null,
    SearchText: '',
  });


  // API Calls
  const [getBookingCancelationList, { isLoading: taskListIsLoading, isSuccess: taskListIsSuccess, data: taskListData }] = useGetBookingCancellationListMutation();

  useEffect(() => {
    getBookingCancelationList(pagination);
  }, []);

  useEffect(() => {
    if (!taskListIsLoading && taskListIsSuccess && taskListData) {
      console.log("taskListData", taskListData?.itemList);
      setDataSource(taskListData?.itemList)
      setPagination({ ...pagination, totalCount: taskListData.totalCount });
    }
  }, [taskListIsLoading, taskListIsSuccess, taskListData]);

  // Functions
  const geBookingListData = (data) => {
    getBookingCancelationList(data);
  }

  const handlePageChange = (page) => {
    const { pageNumber, pageSize } = page;
    geBookingListData({ ...pagination, pageSize: pageSize, pageNo: pageNumber })
  };

  const searchClick = () => {
    let formData = filterRef?.current?.getFormData();
    let request = {
      ...paginationObj,
      SearchText: formData?.searchText || '',
      ApplicationStatusId: formData?.applicationStatus?.value || null,
      Email: formData?.email || null,
      MembershipTypeId: formData?.membershipType?.value || null,
    }
    setPagination(prev => { return { ...prev, ...request } });
    geBookingListData(request);
  };

  const handleEditClick = (rowData, index) => {
    const { cancellationId, } = rowData;
    if (cancellationId)
      navigate(`/BookingCancellationDetails/${encryptAESID(cancellationId)}`)
  };


  const handleClearClick = () => {
    const formData = { ...viewBookingList };
    formData.initialState = {
      email: null,
      membershipType: null,
      applicationStatus: null,
    }
    let request = {
      ...paginationObj,
      ApplicationStatusId: null,
      Email: null,
      MembershipTypeId: null,
    }
    setPagination(prev => { return { ...prev, ...request } });
    geBookingListData(request);
    setBookingList(formData);
  }

  const actionHandler = {
    EDIT: handleEditClick,
  };

  return (
    <div>
      <div className="membership-application">
        <div className="form-card">
          <Suspense fallback={<DataLoader />}>
            <div className="row">
              <FormCreator
                config={viewBookingList}
                ref={filterRef}
                key={false}
              />
              <div className="col-lg-12">
                <div className="d-flex  justify-content-between align-items-between">
                  <h5 className="align-self-end mb-0">Total Count: {taskListData?.totalCount || 0}</h5>
                  <div className="d-flex justify-content-end align-items-center">
                    <Buttons
                      onClick={handleClearClick}
                      buttonText={"Clear"}
                      buttonTypeClassName="back-btn btn "
                      isLoading={false}
                    />
                    <Buttons
                      onClick={searchClick}
                      buttonText={"Search"}
                      buttonTypeClassName="theme-btn btn  ml-3"
                      isLoading={taskListIsLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Suspense>
          <div className="table-100 mt-2">

            <FinalMolGrid
              ref={molGridRef}
              configuration={BookingCancelationListConfig}
              dataSource={dataSource}
              isLoading={taskListIsLoading}
              allowPagination={true}
              pagination={pagination}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingCancelationListForm;
